import { render, staticRenderFns } from "./view3.vue?vue&type=template&id=3ef5496a&scoped=true"
import script from "./view3.vue?vue&type=script&lang=js"
export * from "./view3.vue?vue&type=script&lang=js"
import style0 from "./view3.vue?vue&type=style&index=0&id=3ef5496a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5496a",
  null
  
)

export default component.exports